import { createSlice, createSelector } from "@reduxjs/toolkit";
import { StandardObject } from "utils";

interface PdfState {
  pdfPassword: StandardObject<string>;
  loadedPages: StandardObject<number>;
}

const initialState: PdfState = {
  pdfPassword: {},
  loadedPages: {},
};

const pdfSlice = createSlice({
  name: "pdf",
  initialState,
  reducers: {
    setPdfPassword: (state, action) => {
      const { src, password } = action.payload;
      state.pdfPassword[src] = password;
    },
  },
});

const selectPdf = (state: { pdf: PdfState }) => state.pdf;

export const selectPdfState = createSelector([selectPdf], (s: PdfState) => {
  return {
    pdfPassword: s.pdfPassword,
  };
});

export const { setPdfPassword } = pdfSlice.actions;

export default pdfSlice.reducer;
